export const PermissionsEndpoints = {
  GET_ALL_PERMISSIONS: '/api/admin/permissions',
  GET_PERMISSION_BY_ID: '/api/admin/permissions/get',
  CREATE_PERMISSION: '/api/admin/permissions',
  UPDATE_PERMISSION: '/api/admin/permissions',
  DELETE_PERMISSION: '/api/admin/permissions',
};
